import { Box, chakra, Flex } from '@stockx/ui';

export const SearchInputWrapper = chakra('div', {
  baseStyle: {
    position: 'relative',
    flexGrow: '1',
    'input::-webkit-search-cancel-button:hover': {
      cursor: 'pointer',
    },
  },
  label: 'SearchInputWrapper',
});

export const SearchResultsWrapper = chakra('div', {
  baseStyle: {
    backgroundColor: 'neutral.white',
    borderRadius: '2px',
    color: 'neutral.black',
    margin: 'auto',
    overflowY: 'scroll',
    padding: 0,
    textAlign: 'left',
    left: 0,
    width: '100%',
    zIndex: '1024',
    ul: {
      paddingLeft: 0,
      margin: 0,
      listStyle: 'none',
    },
    '&#home-results': {
      top: '48px',
      maxHeight: '580px',
      padding: 0,
      border: '1px solid',
      paddingTop: 2,
      borderColor: 'neutral.300',
    },

    '.list-item-footer': {
      textAlign: 'center',
      width: '100%',
      fontSize: '15px',
    },

    '.load-more': {
      textAlign: 'center',

      div: {
        paddingTop: '30px',
        paddingBottom: '20px',

        a: {
          marginTop: '6px',
          padding: '8px 30px',
          color: 'neutral.black',
          letterSpacing: '1.4px',
          border: '2px solid',
          borderColor: 'green.500',
          width: '100%',
          font: '600 22px',
        },
      },
    },
  },
  label: 'SearchResultsWrapper',
});

export const SearchOverlayWrapper = chakra(Box, {
  baseStyle: {
    backgroundColor: 'neutral.white',
    height: '100%',
    zIndex: 4,
    padding: 0,
    paddingTop: { base: 4, md: 0 },
    paddingLeft: 0,
    paddingRight: 0,
    width: '100%',
    position: 'absolute',
    top: { base: 0, md: '10px' },
    left: { base: 0, md: 'undefined' },
    right: { base: 0, md: 'undefined' },
  },
  label: 'SearchOverlayWrapper',
});

export const SearchResultItemWrapper = chakra('li', {
  baseStyle: {
    borderBottom: '1px solid',
    borderBottomColor: 'neutral.300',
    paddingBottom: '10px',
    position: 'relative',
    textTransform: 'uppercase',
    transition: 'all 0.2s ease-in-out',
    borderRight: 'none',
    _hover: {
      borderRight: '8px solid',
      borderRightColor: 'green.700',
      cursor: 'pointer',
    },
    _focus: {
      borderRight: '8px solid',
      borderRightColor: 'green.700',
    },
  },
  label: 'SearchResultItemWrapper',
});

export const LetUsKnow = chakra('div', {
  baseStyle: {
    border: 'none',
    fontSize: '11px',
    fontWeight: 'bold',
    margin: '0px',
    padding: '15px',
    textTransform: 'uppercase',
    a: {
      color: 'neutral.black',
      textDecoration: 'underline',
    },
  },
  label: 'LetUsKnow',
});

export const SearchResultItemContent = chakra('div', {
  baseStyle: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: '132px',
    overflow: 'hidden',
    padding: '8px',
    width: '100%',
  },
  label: 'SearchResultItemContent',
});

export const ItemSuperTitle = chakra(Box, {
  baseStyle: {
    fontSize: '11.85px',
    lineHeight: '18px',
    marginBottom: 0,
    '@media (max-width: 470px)': {
      marginBottom: '3px',
    },
  },
  label: 'ItemSuperTitle',
});

export const ItemTitle = chakra(Box, {
  baseStyle: {
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '18px',
    margin: '0px',
    maxHeight: 'none',
    overflow: 'hidden',
    webkitFontSmoothing: 'antialiased',
    '@media (max-width: 470px)': {
      fontSize: '19px',
      lineHeight: '19px',
    },
  },
  label: 'ItemTitle',
});

export const ItemSubTitle = chakra(Box, {
  baseStyle: {
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '17px',
    marginTop: 0,
    webkitFontSmoothing: 'antialiased',
    '@media (max-width: 470px)': {
      fontSize: '16px',
      lineHeight: '16px',
      marginTop: '5px',
    },
  },
  label: 'ItemSubTitle',
});

export const ResultListItem = chakra('li', {
  baseStyle: {
    display: 'flex',
    alignItems: 'center',
    minHeight: '113px',
    paddingY: 3,
    borderBottom: '1px solid',
    borderBottomColor: 'neutral.300',
    transition: 'all 0.2s ease-in-out',
    borderRight: 'none',
    _hover: {
      borderRight: '4px solid',
      borderRightColor: 'green.700',
      background: 'neutral.100',
      cursor: 'pointer',
      '&>div': {
        '&>div': {
          'p:nth-of-type(2)': {
            fontFamily: 'suisseIntlMedium',
          },
          'p:nth-of-type(1)': {
            fontFamily: 'suisseIntlBold',
          },
        },
      },
    },
    _focus: {
      borderRight: '8px solid',
      borderRightColor: 'green.700',
    },
  },
  label: 'ResultListItem',
});

export const ProductCellFlex = chakra(Flex, {
  baseStyle: {
    alignItems: 'center',
    cursor: 'pointer',
    height: '100%',
  },
  label: 'ProductCellFlex',
});
